import React from "react";
import { MaskedText } from "../common";

const DeliveryCompleteScreen = ({ winnerInfo }) => {
  if (!winnerInfo) return null;

  const { name, phone, deliveredAt } = winnerInfo;

  return (
    <div className="newyear-delivery-complete">
      <div className="newyear-delivery-complete__icon">
        <span className="newyear-delivery-complete__emoji">
          &#128230;
        </span>
      </div>

      <h2 className="newyear-delivery-complete__title">발송 완료</h2>
      <p className="newyear-delivery-complete__message">
        경품이 발송되었습니다!
      </p>

      <div className="newyear-delivery-complete__info">
        <div className="newyear-delivery-complete__row">
          <span className="newyear-delivery-complete__label">수령인</span>
          <span className="newyear-delivery-complete__value">
            <MaskedText value={name} type="name" />
          </span>
        </div>

        <div className="newyear-delivery-complete__row">
          <span className="newyear-delivery-complete__label">연락처</span>
          <span className="newyear-delivery-complete__value">
            <MaskedText value={phone} type="phone" />
          </span>
        </div>

        {deliveredAt && (
          <div className="newyear-delivery-complete__row">
            <span className="newyear-delivery-complete__label">발송일</span>
            <span className="newyear-delivery-complete__value">
              {new Date(deliveredAt).toLocaleDateString("ko-KR")}
            </span>
          </div>
        )}
      </div>

      <div className="newyear-delivery-complete__notice">
        <p>이벤트에 참여해주셔서 감사합니다!</p>
      </div>
    </div>
  );
};

export default DeliveryCompleteScreen;
